































import {
  defineComponent,
  onActivated,
  onMounted,
  ref,
} from "@vue/composition-api";
import Navigation from "./components/Navigation.vue";
import router from "@/router/index";
import { getPestDetail, IResPest } from "@/api/diseasePest";
import { ImagePreview } from "vant";
import "vant/lib/image-preview/style";
import { goBack } from "@/utils/goBack";

type InfoItem<SubType> = {
  label: string;
  value?: string;
  key: keyof SubType;
  render?: (row: SubType) => string | undefined;
};
type PestOtherInfoItem = InfoItem<IResPest>;

export default defineComponent({
  name: "pestDetail",
  components: {
    Navigation,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },

  setup() {
    const pageTitle = ref("病害详情");
    const id = ref(0);
    id.value = (router.currentRoute.query.id as unknown) as number;
    const info = ref<IResPest>({});
    const otherInfo = ref<PestOtherInfoItem[]>([
      {
        label: "发病症状",
        key: "symptom",
      },
      {
        label: "防治方法",
        key: "prevent",
      },
      {
        label: "发病因素",
        key: "factor",
      },
      {
        label: "传播途径",
        key: "spread",
      },
      {
        label: "形态特征",
        key: "shape",
      },
      {
        label: "生活习性",
        key: "habit",
      },
      {
        label: "危害",
        key: "harm",
      },
    ]);
    const getDetail = async () => {
      const [err, data] = await getPestDetail({ id: id.value });
      if (!err && data != null) {
        info.value = data;
        pageTitle.value = data.type == 1 ? "病害详情" : "虫害详情";
        otherInfo.value.forEach((item) => {
          item.value = data[item.key]?.toString();
        });
        otherInfo.value = otherInfo.value.filter((i) => i.value != "");
      }
    };
    onMounted(() => {
      getDetail();
    });
    onActivated(() => {
      id.value = (router.currentRoute.query.id as unknown) as number;
      getDetail();
    });

    return {
      handleBack: () => {
        goBack();
      },
      pageTitle,
      info,
      otherInfo,
      handleOpenImage: (index: number) => {
        ImagePreview({
          images:
            info.value.absolutePathImages != null
              ? info.value.absolutePathImages
              : [],
          startPosition: index,
          closeable: true,
        });
      },
    };
  },
});
